module.exports = __webpack_public_path__ + "img/icon-plus.967e6c47.svg";